import React from 'react'

const LineArrowRight = (props) => {
	return(
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="8" viewBox="0 0 18 8"><path d="M.7 135.355h14.893l-2.466-2.255a.608.608 0 0 1 0-.912.749.749 0 0 1 .994 0l3.674 3.355a.609.609 0 0 1 0 .913l-3.674 3.355a.749.749 0 0 1-.994 0 .608.608 0 0 1 0-.912l2.467-2.252h-14.894a.648.648 0 1 1 0-1.29z" transform="translate(0 -132)" fill={props.fill}   /></svg>
	)
}

export default LineArrowRight